module.exports = __webpack_public_path__ + "img/16l012-09.105df04e.png";